/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
export default [[["miezul nopții", "amiază", "dimineață", "după-amiază", "seară", "noapte"], ["miezul nopții", "amiază", "dimineața", "după-amiaza", "seara", "noaptea"], u], u, ["00:00", "12:00", ["05:00", "12:00"], ["12:00", "18:00"], ["18:00", "22:00"], ["22:00", "05:00"]]];
